// # WORKSPACES: compatibilidad centralizada para enlaces históricos de las tres áreas.
export function canonicalWorkspacePath(pathname = "") {
  if (/^\/(?:dashboard\/superpanel|superadmin)\/almacenamiento\/?$/.test(pathname)) return "/owner";
  if (/^\/dashboard\/owner(?:\/|$)/.test(pathname)) return pathname.replace("/dashboard/owner", "/owner");
  if (/^\/dashboard\/superpanel(?:\/|$)/.test(pathname)) return pathname.replace("/dashboard/superpanel", "/superadmin");
  if (/^\/dashboard\/(?:usuarios|actividad|analitica)(?:\/|$)/.test(pathname)) return pathname.replace("/dashboard/", "/superadmin/");
  return pathname;
}

export function defaultWorkspacePath(user) {
  if (user?.isSuperAdmin || user?.globalRole === "superadmin") return "/superadmin";
  if (user?.seller?.active) return "/vendedores";
  return "/dashboard";
}
